import script from "./sourcePage.vue?vue&type=script&setup=true&lang=js"
export * from "./sourcePage.vue?vue&type=script&setup=true&lang=js"

import "./sourcePage.vue?vue&type=style&index=0&id=621b0c1c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621b0c1c"]])

export default __exports__